import {Component, OnInit, Injectable, Inject} from 'ng-metadata/core';
import {TagsSearchBarService} from './tagsSearchBar.service';
import {TagsService} from '../tags.service';
import {MediaQueries} from "../../infra/mediaQueries.service";
import {getVid} from "../../appConfig/appConfigForward";
import {MappingTablesCache} from "../../mappingTablesCache/mappingTablesCache.service";
import {PagesTitlesService} from "../../infra/accessibility/pagesTitles.service";
import {ConfigurationUtil} from "../../nddUtils/configurationUtil.service";

@Component({
    selector: 'prm-tags-search-bar',
    templateUrl: 'components/tags/tagsSearchBar/tags-search-bar.html',
})

export class PrmTagsSearchBar {
    public mainSearchField: string;
    private focusOnSearchInput: boolean = false;
    private vid = getVid();

    constructor(private tagsService: TagsService,
                private tagsSearchBarService: TagsSearchBarService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$element') private $element,
                private mediaQueries: MediaQueries,
                private mtCache: MappingTablesCache,
                @Inject('$state') private $state: ng.ui.IStateService,
                private pagesTitlesService: PagesTitlesService,
                private configurationUtil: ConfigurationUtil) {

        this.focusOnSearchInput = (this.mtCache.getTable(this.mtCache.tables.VIEW_PROPERTIES).filter((row) => row.source1 === this.vid && row.source2 === 'focus_on_search_input' && row.target === 'true').length === 1);

    }

    ngOnInit() {
        this.$scope.$watch(() => this.mainSearchField, (newVal, oldVal) => {
            this.$timeout(() => {
                this.removeAriaLabel('md-input-container input');
            }, 400);
        });

        // Set autofocus to input search bar
        this.$timeout(() => {
            if (this.mediaQueries.gtmd && this.focusOnSearchInput) {
                let elem = document.querySelector('#searchBarTags');
                if (elem) {
                    elem.focus();
                }
            }
        }, 0);
    }

    /*
    performs a tags search containing the mainSearchField
    */
    public doTagsSearch() {
        if (this.mainSearchField.length === 0) {
            this.tagsService.isInSearch = false;
        } else {
            this.tagsService.isInSearch = true;
        }
        this.tagsService.doTagsSearch(this.mainSearchField);

        // Only for mobile -  This for auto-closing of the keyboard when the user clicks search from the mobile keyboard button
        if (!this.mediaQueries.gtmd) {
            document.getElementById("searchBarTags").blur();
        }

        this.updateTagsPageTitle()
    }

    private updateTagsPageTitle() {
        let searchQuery = this.mainSearchField;
        let actionToCode = {
            'tags': !this.isSuprima() ? ['nui.mainmenu.label.tags', '$$QUERY$$'] : ['mainmenu.label.tags', '$$QUERY$$'],
        };

        let titles = {codes: actionToCode[this.$state.current.name], query: searchQuery};
        this.pagesTitlesService.updatePagesTitles(titles);
    }

    public isSuprima() {
        return this.configurationUtil.isSuprima();
    }

    //this function remove aria-label from search edit field.
    private removeAriaLabel(str) {
        let searchEditField: [Element] = this.$element[0].querySelectorAll(str);
        for (let input of searchEditField) {
            input.removeAttribute('aria-label');
        }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/tags/tagsSearchBar/tagsSearchBar.directive.ts